var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "tabs-title",
      class: { "is-active": _vm.isActive, "boss-new": _vm.hasUnread },
      attrs: { "data-test": "" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "router-link",
        { staticClass: "boss-tabs-link", attrs: { to: _vm.link } },
        [
          _c("span", { staticClass: "boss-icon", class: _vm.iconName }),
          _vm._v(_vm._s(_vm.title) + "\n    "),
          _vm.tooltip
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: { content: _vm.tooltip },
                      expression: "{ content: tooltip}",
                    },
                  ],
                  staticClass: "pega-circle",
                },
                [_vm._v("?\n    ")]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }